"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _utils = require("../utils");

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 * Fallback to an appropriate log type
 * for types that dd-trace doesn't accept
 *
 * Types dd-trace does accept can be found here
 * https://github.com/DataDog/dd-trace-js/blob/f68c28f94c964a6bebf7ccac65a0bb817f03bd9d/packages/dd-trace/src/log.js#L13-L18
 */
var logLevelsMap = {
  trace: 'debug',
  debug: 'debug',
  info: 'info',
  success: 'info',
  log: 'info',
  warn: 'warn',
  error: 'error',
  fatal: 'error'
};
/**
 * A class to format log objects for DataDog.
 *
 * Be careful when modifying the log object, attributes names follow DataDog
 * conventions and some enable specific functionality. Most of these attributes
 * are currently documented here
 * https://docs.datadoghq.com/logs/processing/attributes_naming_convention/
 *
 * Note that this is currently only intended for server-side logging; client-side
 * logging could later be enabled via @datadog/browser-logs
 */

var DataDogReporter = /*#__PURE__*/function () {
  function DataDogReporter(name) {
    var meta = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, DataDogReporter);

    this.name = name;
    this.meta = meta;
  }

  _createClass(DataDogReporter, [{
    key: "formatLogObject",
    value: function formatLogObject(logObj) {
      var args = [].concat(logObj.args);
      var arg0 = args.shift();
      var defaultMeta = (0, _utils.getDefaultLogMeta)();

      var logAttrs = _objectSpread(_objectSpread(_objectSpread({
        date: logObj.date,
        level: logLevelsMap[logObj.type] || 'info',
        forcePush: (arg0 === null || arg0 === void 0 ? void 0 : arg0.forcePush) || false,
        logger: {
          name: this.name
        },
        message: arg0,
        status: logObj.type || 'info'
      }, this.meta), defaultMeta), _typeof(args[0]) === 'object' ? args[0] : {
        args: args[0]
      });

      if (arg0 instanceof Error) {
        logAttrs.message = '';
        logAttrs.error = {
          stack: arg0.stack,
          message: arg0.message
        }; // VerboseError sets a logAttrs object. However, as it is possible that
        // this error gets caught and rethrown as a different type we can't check
        // instanceof VerboseError directly. Instead, check if the error object has
        // a logAttrs property. If modifying this be careful that 404s don't start
        // polluting our DataDog logs, for example.

        if (arg0.logAttrs) {
          Object.assign(logAttrs, arg0.logAttrs || {});
        }
      }

      return logAttrs;
    }
  }, {
    key: "log",
    value: function log(logObj) {
      var _window$DD_LOGS;

      var formatedLogObj = this.formatLogObject(logObj); // we dont touch the shouldLog and additionally check for forcePush
      // if it shouldnt log, but the force push is true, then we should log

      if (!(0, _utils.shouldLog)(logObj.type) && !formatedLogObj.forcePush) {
        return;
      }

      if (typeof window === 'undefined') {
        var tracer = require('dd-trace');

        var ddTracerFormats = require('dd-trace/ext/formats');

        var span = tracer.scope().active();

        if (span) {
          // inject span and trace IDs to connect traces with associated spans
          tracer.inject(span.context(), ddTracerFormats.LOG, formatedLogObj);
        } // Write to stdout on the server


        process.stdout.write("".concat(JSON.stringify(formatedLogObj), "\n"));
        return;
      } // Do nothing if the DataDog browser client has not been added to the page


      if (!((_window$DD_LOGS = window.DD_LOGS) === null || _window$DD_LOGS === void 0 ? void 0 : _window$DD_LOGS.logger)) {
        return;
      } // Do not send `trace` or `log` messages to DataDog to avoid things getting
      // too spammy.


      if (logObj.level === (0, _utils.getConsolaLevel)('log') || logObj.level === (0, _utils.getConsolaLevel)('trace')) {
        return;
      } // if we dont force push logs, then we wont send them
      // unless its an error as we always want errors captured.


      if (!formatedLogObj.forcePush && logObj.level !== (0, _utils.getConsolaLevel)('error')) {
        return;
      }

      window.DD_LOGS.logger.log(formatedLogObj.message, formatedLogObj);
    }
  }]);

  return DataDogReporter;
}();

exports["default"] = DataDogReporter;